import * as React from "react";
import type { IIconProps } from "native-base";
import Star from "./Star";

export const StarOutline = (props: IIconProps) => <Star isOutline {...props} />;

export default StarOutline;
